<section>
  <div class="container pt-5 pb-5">
    <h1 class="font-title font-bold">Delivery Policy</h1>

    <h3 class="font-title font-bold mb-2 mt-4">
      How do I contact the retailer?
    </h3>
    <p class="mb-4 text-theme-on-surface">
      EnableAll is an online marketplace that connects you with thousands of
      retailers. You are buying directly from these businesses, and they are
      responsible for providing the right information in all their product
      listings.
    </p>
    <p class="mb-4 text-theme-on-surface">
      We are currently in the process of making improvements to our platform to
      provide you with a better shopping experience. As a result, you are
      temporarily unable to contact retailers directly before purchasing an
      item.
    </p>
    <p class="mb-4 text-theme-on-surface">
      If you have seen a product listed on the site that you are concerned
      about, please report these to us here.
    </p>
    <h3 class="font-title font-bold mb-2 mt-4">
      Tracking and delivery for my order
    </h3>
    <p class="mb-4 text-theme-on-surface">
      If the retailer you ordered from chose to use a tracked delivery method,
      you will find the name of the courier and tracking number in your dispatch
      confirmation email.
    </p>
    <p class="mb-4 text-theme-on-surface">
      You can also find your tracking information on the View Orders section of
      your EnableAll account. Simply log into your account, find the relevant
      order and click ‘View Order Details’.
    </p>

    <p class="mb-4 text-theme-on-surface">
      If you can’t see the delivery status of your order, don’t worry, some
      couriers take up to 24hrs to update tracking details after they’ve
      received the package.
    </p>
    <p class="mb-3 text-theme-on-surface">
      If you checked out as a guest, you can still track your order. In your
      order dispatch confirmation e-mail, there will be a link to the tracking
      data, if the retailer you chose to order from, used a tracked delivery
      method.
    </p>
    <p class="mb-3 text-theme-on-surface">
      Please note: EnableAll is an online marketplace that connects retailers
      with customers. We don’t dispatch anything ourselves, so we won’t be able
      to provide you with any tracking information.
    </p>
    <h3 class="font-title font-bold mb-2 mt-4">
      Can you provide a VAT invoice?
    </h3>
    <p class="mb-3 text-theme-on-surface">
      Yes, most of the retailers selling on EnableAll can provide you with a VAT
      invoice where they are a VAT registered business.
    </p>
    <p class="mb-3 text-theme-on-surface">
      You can contact the retailer you ordered from directly through your
      EnableAll account. Log in to your account and go to View Orders; find the
      relevant order and click ‘Contact Seller’ to ask the retailer to provide a
      VAT invoice. They will be able to confirm whether an invoice is available
      and provide it accordingly.
    </p>
    <p class="mb-3 text-theme-on-surface">
      If you checked out as a guest, to contact the seller and request a VAT
      invoice, you'll need to create an EnableAll account.
    </p>
    <p class="mb-3 text-theme-on-surface">
      It's easy to do, just follow this link and be sure to use the same e-mail
      address that you used when you placed your order, so the order links
      successfully to your new account.
    </p>
    <h3 class="font-title font-bold mb-2 mt-4">Can you cancel an order?</h3>
    <p class="mb-3 text-theme-on-surface">
      Yes, of course! Simply log in to your EnableAll account and locate your
      order. Click ‘Cancel Order’ and select your reason for cancelling.
    </p>
    <p class="mb-3 text-theme-on-surface">
      Your cancellation request will be sent to the retailer for confirmation.
      They will contact you directly if there are any issues.
    </p>
    <p class="mb-3 text-theme-on-surface">
      If the retailer hasn’t been able to cancel your order, don’t worry. You
      have 30 days to return it for a full refund. If you are required to pay
      postage, please see ‘How do I return my products?’ for details on securing
      a full refund.
    </p>
    <p class="mb-3 text-theme-on-surface">
      If you checked out as a guest, to contact the retailer to arrange a
      cancellation, you'll need to create an EnableAll account.
    </p>
    <p class="mb-3 text-theme-on-surface">
      It's easy to do, just follow this link and be sure to use the same e-mail
      address that you used when you placed your order, so the order links
      successfully to your new account.
    </p>
    <h3 class="font-title font-bold mb-2 mt-4">
      I have a faulty item or an issue with a product
    </h3>
    <p class="mb-3 text-theme-on-surface">
      The first thing to do is to contact the retailer you ordered from
      directly. Log into your EnableAll account and go to view orders. Find the
      order in question and click ‘Contact Seller’, you can message them
      directly from here and you should get a reply within 48 hours.
    </p>
    <p class="mb-3 text-theme-on-surface">
      If the seller doesn’t resolve the issue to your satisfaction, then pop
      onto a chat with our Chat Bot (you''ll see the chat icon at the bottom of
      this page). Our Chat Bot will be able to advise you further and will
      connect you with the EnableAll Customer Care team if you need more
      assistance.
    </p>
    <p class="mb-3 text-theme-on-surface">
      If you checked out as a guest, to contact the retailer, you'll need to
      create an EnableAll account.
    </p>
    <p class="mb-3 text-theme-on-surface">
      It's easy to do, just follow this link and be sure to use the same e-mail
      address that you used when you placed your order, so the order links
      successfully to your new account.
    </p>
  </div>
</section>
